import { ModelType } from '@tarslib/types/lib/common';
import { URL_RESOURCE_KEY_TYPE_ABBR } from '@tarslib/types/lib/projectSetting';
import { RelatedType } from '@tarslib/types/lib/seoInfo';
import { TypeInRoute } from '../constant/TypeInRoute';

export function typeInRouteToModelType(type: TypeInRoute): ModelType {
  const modelTypeMap: Record<TypeInRoute, ModelType> = {
    [TypeInRoute.Api]: ModelType.HttpApi,
    [TypeInRoute.Doc]: ModelType.Doc,
    [TypeInRoute.ApiFolder]: ModelType.ApiFolder,
    [TypeInRoute.WebSocketApi]: ModelType.WebSocketApi,
    [TypeInRoute.CustomEndpoint]: ModelType.CUSTOM_ENDPOINT,
    [TypeInRoute.ApiCase]: ModelType.HttpApiCase,
    [TypeInRoute.DeprecatedApi]: ModelType.HttpApi,
    [TypeInRoute.SocketIOApi]: ModelType.SOCKET_IO_API,
    [TypeInRoute.ApiSchema]: ModelType.ApiSchema,
  };

  return modelTypeMap[type];
}

export function typeInRouteToRelatedType(type: TypeInRoute): RelatedType | undefined {
  const relatedTypeMap: Record<TypeInRoute, RelatedType | undefined> = {
    [TypeInRoute.Api]: RelatedType.HTTP_API,
    [TypeInRoute.Doc]: RelatedType.DOC,
    [TypeInRoute.ApiFolder]: RelatedType.API_FOLDER,
    [TypeInRoute.WebSocketApi]: RelatedType.WEB_SOCKET_API,
    [TypeInRoute.CustomEndpoint]: RelatedType.CUSTOM_ENDPOINT,
    [TypeInRoute.SocketIOApi]: RelatedType.SOCKET_IO_API,
    [TypeInRoute.DeprecatedApi]: undefined,
    [TypeInRoute.ApiCase]: undefined,
    [TypeInRoute.ApiSchema]: RelatedType.DATA_SCHEMA,
  };
  return relatedTypeMap[type];
}

export function typeInRouteToUrlResourceKeyTypeAbbr(
  type: TypeInRoute,
): URL_RESOURCE_KEY_TYPE_ABBR | undefined {
  const resourceKeyTypeAbbrMap: Record<TypeInRoute, URL_RESOURCE_KEY_TYPE_ABBR | undefined> = {
    [TypeInRoute.DeprecatedApi]: URL_RESOURCE_KEY_TYPE_ABBR.Endpoint,
    [TypeInRoute.Api]: URL_RESOURCE_KEY_TYPE_ABBR.Endpoint,
    [TypeInRoute.Doc]: URL_RESOURCE_KEY_TYPE_ABBR.Doc,
    [TypeInRoute.ApiFolder]: URL_RESOURCE_KEY_TYPE_ABBR.ApiFolder,
    [TypeInRoute.WebSocketApi]: URL_RESOURCE_KEY_TYPE_ABBR.WebSocketEndpoint,
    [TypeInRoute.CustomEndpoint]: URL_RESOURCE_KEY_TYPE_ABBR.CustomEndpoint,
    [TypeInRoute.ApiCase]: undefined,
    [TypeInRoute.SocketIOApi]: URL_RESOURCE_KEY_TYPE_ABBR.SocketIOEndpoint,
    [TypeInRoute.ApiSchema]: URL_RESOURCE_KEY_TYPE_ABBR.DataSchema,
  };

  return resourceKeyTypeAbbrMap[type];
}

export function modelTypeToTypeInRoute(
  type:
    | ModelType.HttpApi
    | ModelType.WebSocketApi
    | ModelType.ApiFolder
    | ModelType.Doc
    | ModelType.CUSTOM_ENDPOINT
    | ModelType.SOCKET_IO_API
    | ModelType.ApiSchema,
): TypeInRoute {
  const typeInRouteMap: Record<
    | ModelType.HttpApi
    | ModelType.WebSocketApi
    | ModelType.ApiFolder
    | ModelType.Doc
    | ModelType.CUSTOM_ENDPOINT
    | ModelType.SOCKET_IO_API
    | ModelType.ApiSchema,
    TypeInRoute
  > = {
    [ModelType.HttpApi]: TypeInRoute.Api,
    [ModelType.Doc]: TypeInRoute.Doc,
    [ModelType.ApiFolder]: TypeInRoute.ApiFolder,
    [ModelType.WebSocketApi]: TypeInRoute.WebSocketApi,
    [ModelType.CUSTOM_ENDPOINT]: TypeInRoute.CustomEndpoint,
    [ModelType.SOCKET_IO_API]: TypeInRoute.SocketIOApi,
    [ModelType.ApiSchema]: TypeInRoute.ApiSchema,
  };

  return typeInRouteMap[type];
}
